import React from "react";

type Props = {};

const LoadingError = (props: Props) => (
  <section className="bg-white min-h-[10rem]">
    <div className="py-8 px-4 mx-auto my-4 max-w-screen-xl lg:py-16 lg:px-6">
      <div className="mx-auto max-w-screen-sm text-center">
        <h1 className="mb-4 text-3xl tracking-tight font-extrabold lg:text-6xl text-primary-600">Oops! 🙈</h1>
        <p className="text-lg font-light text-gray-500">
          Nie udało się wczytać lokat. Spróbuj odświeżyć stronę.
        </p>
      </div>
    </div>
  </section>
);

export default LoadingError;
